import { ApiHandler } from '@eshop/api-client'

import { ServiceProduct } from '#/global/service/Product'

import type { AddToCartEshop, AddToCartEshopAfter } from '#/global/types'

/**
 * @todo přesunout do @eshop/api-client
 */
interface ApiErrorList {
    errors: {
        code: string
        message: string
        path: string
    }[]
}

const addToCartEshop = (event: CustomEvent<AddToCartEshop>) => {
    const detail = event.detail
    const payload = { code: detail.code, quantitySales: detail.quantitySales, unitSales: detail.unitSales }

    const api = new ApiHandler({
        path: '/cart/add-to-cart-eshop',
        method: 'POST',
        body: payload,
    })

    api
        .addResponseHandler('2xx', async () => {
            const result = await ServiceProduct.getProductEshopByCode(detail.code, ['detail', 'price', 'brand', 'availability', 'unit', 'related', 'season'])
            if (result[0] === null) {
                return
            }

            const product = result[0]
            window.dispatchEvent(new CustomEvent<AddToCartEshopAfter>('ES_ADD_TO_CART_ESHOP_AFTER', { detail: {
                ...detail,
                product,
                isSuccess: true,
            } }))
        })
        .addResponseHandler('4xx', async (response) => {
            const body = await api.getData<ApiErrorList>(true)

            // if quantitySales is greater than stock
            if (response.status === 400 && body?.errors.some(error => error.code === '1')) {
                location.href = `${location.href}?modal=StocksLast&productCode=${detail.code}&quantitySales=${detail.quantitySales}`
                return
            }
            await api.handleError()
        })

    api.send().catch((error) => {
        console.error('[GlobalListener-AddToCartEshop]:', error)
    })
}

export default addToCartEshop
